<template>
  <div>
    <div class="msg_head">
      <img src="@/assets/img/device_list/announcement.png" alt="" />
      <span>{{ $t("lang.公告消息") }}</span>
    </div>
    <div class="msg_content" v-infinite-scroll="getLoadData">
      <div v-if="msgList.length == 0" class="noNews">
        {{ $t("lang.暂无消息") }}
      </div>
      <div class="msg_item" v-for="(item, index) in msgList" :key="index">
        <p>{{ item.title }}</p>
        <p>{{ $t("lang.操作时间") }}：{{ item.updateTime }}</p>
        <p>{{ item.content }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  components: {},
  data() {
    return {
      msgList: [],
      pageNum: 0,
    };
  },
  methods: {
    ...mapActions({
      announcementMessageList: "ZD_AnnouncementMessageList",
    }),
    async getAnnouncementMessageList(type) {
      if (type) {
        this.pageNum = 1;
        this.msgList = [];
      }
      let res = await this.announcementMessageList({
        pageNum: this.pageNum,
        pageSize: 15,
        msgType: 3,
        systemid: 21,
        lan: this.$i18n.locale == "zh-CN" ? "zh" : "en",
      });
      if (res.success !== 1) return;
      res.listitem.forEach((item) => {
        item.content = item.content.replace(/\\n/g, "");
      });
      this.msgList.push(...res.listitem);
    },
    getLoadData() {
      this.pageNum += 1;
      this.getAnnouncementMessageList();
    },
    onChangeMonths() {
      this.getAnnouncementMessageList(true);
    },
  },
};
</script>

<style scoped lang='less'>
.msg_head {
  display: flex;
  align-items: center;
  padding: 30px 0 29px 44px;
  border-bottom: 1px solid #ccc;
  img {
    width: 37px;
    height: 37px;
  }
  span {
    font-size: 16px;
    margin: 0 33px 0 20px;
  }
  .el-date-editor {
    width: 157px;
  }
}
.msg_content {
  height: 650px;
  overflow-y: auto;
  .msg_item {
    padding: 31px 40px 29px 44px;
    border-bottom: 1px solid #eee;
  }
  p:nth-of-type(1) {
    font-size: 16px;
    margin-top: 0;
  }
  p {
    font-size: 14px;
    margin-top: 15px;
  }
}
.noNews {
  color: #878787;
  text-align: center;
  padding-top: 50px;
}
</style>